import React from "react";
import successPng from "public/thumbs-up.png";
import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";


import "../../css/main.css";
import "../../css/style.css";

function Home(props) {

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>

          <div className="columns credencial-style">
            <div className="column exist">
              <div style={{ display: "flex" }}>
                <br></br>
                <img
                  src={successPng}
                  alt=""
                  style={{ height: "45px", width: "45px", margin: "auto" }}
                />
              </div>
              <br></br>
              <p></p>
              {props.message}
              <p></p>
              <br></br>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
